import React from 'react';

const PLACEHOLDER_CIRCLES = 3;
const PLACEHOLDER_PILLS = 2;
/** Same text box as a short league name, so the line does not jump when the real name arrives. */
const LEAGUE_NAME_PLACEHOLDER = '\u00A0'.repeat(10);

export function LeagueCirclePlaceholders({ count = PLACEHOLDER_CIRCLES }) {
  const total = Math.max(1, count);
  return (
    <div className="league-selector" aria-hidden="true">
      <div className="league-circles">
        {Array.from({ length: total }, (_, index) => (
          <span key={index} className="league-circle league-circle--placeholder" />
        ))}
      </div>
      <span className="league-name">{LEAGUE_NAME_PLACEHOLDER}</span>
    </div>
  );
}

export function ButtonPlaceholders({ count = PLACEHOLDER_PILLS, variant = 'pill' }) {
  const total = Math.max(1, count);
  const rowClass = variant === 'action' ? 'home-actions' : 'round-selector';
  const itemClass = variant === 'action'
    ? 'action-btn action-btn--placeholder'
    : 'round-pill round-pill--placeholder';
  return (
    <div className={rowClass} aria-hidden="true">
      {Array.from({ length: total }, (_, index) => (
        <span key={index} className={itemClass} />
      ))}
    </div>
  );
}
